import { motion } from 'framer-motion'
import BrandShell from '../components/BrandShell.jsx'
import { useRealtimeLeaderboard } from '../hooks/useRealtimeLeaderboard.js'
import { quarterTimeRemaining } from '../lib/dateUtils.js'
import LeaderboardRow from '../components/LeaderboardRow.jsx'
import { Reorder } from 'framer-motion'

const PRIZES = [
  { rank: 1, label: '1st place', amount: 1000 },
  { rank: 2, label: '2nd place', amount: 500 },
  { rank: 3, label: 'Best single post', amount: 250, note: 'Judged by Lennon' },
]

export default function Results() {
  const { rows } = useRealtimeLeaderboard()
  const time = quarterTimeRemaining()

  return (
    <BrandShell>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10 space-y-8">
        <motion.header
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center"
        >
          <span className="font-display text-2xl text-brand-blue">Results</span>
          <h1 className="text-4xl font-bold text-brand-text">Q2 2026 final standings</h1>
          {!time.ended && (
            <p className="text-sm text-brand-text-muted mt-2">
              Provisional. The leaderboard is still live.
            </p>
          )}
          {time.ended && (
            <p className="text-sm text-brand-success mt-2">Final and locked.</p>
          )}
        </motion.header>

        <section className="grid sm:grid-cols-3 gap-4">
          {PRIZES.map((p, i) => {
            const winner = rows[p.rank - 1]
            return (
              <motion.div
                key={p.label}
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1 }}
                className="bg-white border border-brand-border rounded-2xl p-6 text-center shadow-card"
              >
                <div className="text-5xl mb-2">{p.rank === 1 ? '👑' : p.rank === 2 ? '🥈' : '✨'}</div>
                <div className="text-sm uppercase tracking-wider text-brand-text-muted">{p.label}</div>
                <div className="text-3xl font-bold text-brand-text mt-1">£{p.amount.toLocaleString()}</div>
                {winner && p.rank <= 2 && (
                  <div className="text-sm text-brand-text mt-3 font-semibold">{winner.participant.name}</div>
                )}
                {p.note && <p className="text-xs text-brand-text-muted mt-2">{p.note}</p>}
              </motion.div>
            )
          })}
        </section>

        <Reorder.Group axis="y" values={rows} onReorder={() => {}} className="space-y-3">
          {rows.map(r => (
            <LeaderboardRow key={r.participant.id} row={r} />
          ))}
        </Reorder.Group>
      </div>
    </BrandShell>
  )
}
